import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from "react";
import { LANGUAGE } from "./type";

interface ContextValue {
	language: string;
	setLanguage: Dispatch<SetStateAction<string>>;
}

export const initialValue = {
  language: "",
  setLanguage: () => {},
};

const Context = createContext<ContextValue>(initialValue);

const ContextProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<string>(LANGUAGE.DE);

  return (
    <Context.Provider
      value={{
        language,
        setLanguage,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export { ContextProvider, Context };
